import { EmptyState } from '@backstage/core-components';
import { CatalogTableRow } from '@backstage/plugin-catalog';
import { FEAST_TYPE, FEATURE_STORE_TYPE, routes } from '../../lib/viva';
import { EntityArgoAppsCell } from '../catalog/cells';
import { feastColumns } from '../catalog/columns';
import { TypedCatalogPage } from '../catalog/TypedCatalogPage';
import { EntityFeastStateCell } from './FeastCells';

const columns = feastColumns<CatalogTableRow>(
  row => <EntityArgoAppsCell entity={row.entity} />,
  row => <EntityFeastStateCell entity={row.entity} />,
);

export const FeastPage = () => (
  <TypedCatalogPage
    section="feast"
    title="Feast"
    subtitle="Feature store платформы: по одному Feast на кластер и репозитории признаков команд"
    kind="component"
    type={[FEAST_TYPE, FEATURE_STORE_TYPE]}
    columns={columns}
    create={{ title: 'Репозиторий признаков', to: routes.newFeatureRepo }}
    support="Feast разворачивается с каждым кластером платформы (gitops platform/<кластер>/18-feast.yaml; реестр и online store — Postgres, offline store — parquet в бакете датасетов) и регистрируется в каталоге шаблоном «Новый Kubernetes-кластер». Определения признаков живут в репозиториях признаков (шаблон «Репозиторий признаков (Feast)»): feast plan на MR, feast apply на main; модели подключают их input'ом features_repo."
    emptyContent={
      <EmptyState
        missing="data"
        title="Feast пока нет"
        description="Feast появляется вместе с кластером: создайте кластер из шаблона «Новый Kubernetes-кластер», затем репозиторий признаков."
      />
    }
  />
);
